module.exports = __webpack_public_path__ + "static/media/logo-dark.de5332f1.svg";